if (!customElements.get('product-description-expand')) {
  customElements.define('product-description-expand', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const content = this.querySelector('.rte');
      const button = this.querySelector('button');
      if (!content || !button) return;
      this.initialized = true;
      const count = Number(this.dataset.paragraphs);
      if (!Number.isInteger(count) || count < 1) return;
      const paragraphs = Array.from(content.children).filter(node =>
        node.tagName === 'P' && (node.textContent.trim() || node.querySelector('img, video, iframe'))
      );
      const boundary = paragraphs[count - 1];
      if (!boundary) return;
      const range = document.createRange();
      range.setStartAfter(boundary);
      range.setEnd(content, content.childNodes.length);
      const tail = range.extractContents();
      if (!tail.textContent.trim() && !tail.querySelector('img, video, iframe, table, ul, ol')) {
        content.append(tail);
        return;
      }
      const more = document.createElement('div');
      more.hidden = true;
      more.append(tail);
      content.append(more);
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        more.hidden = !expanded;
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
      });
    }
  });
}
